import React, { Fragment, useEffect, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import KjosandiInfo from "./KjosandiInfo";
import KjosandiAdstod from "./KjosandiAdstod";
import KjosandiAtkvaedi from './KjosandiAtkvaedi';
import { AppContext } from "store/AppContext";


export default function FormStep(props) {
  const context = useContext(AppContext);
  const { formState, setFormState, kjosandiInfo, atkvaediOptions, handleNext, handleBack } = props;
  const { kjosandi, fjoldiAtkvaeda } = kjosandiInfo;
  
  useEffect(() => {
    setFormState(state => ({
      ...state,
      kennitala: kjosandi.kennitala,
      nafn: kjosandi.nafn,
      heimili: kjosandi.husheiti,
      sveitarfelagsnumer: kjosandi.sveitarfelagsnumer,
      numerKjordaemis: kjosandi.numerKjordaemis,
      kjorstadurNumer: kjosandi.kjorstadurNumer,
      kjordeild: kjosandi.kjordeild,
      notandi: context.user.get.details.saml_username,
      notandiKt: context.user.get.details.saml_userssn,
      notandiEmbaettisnumer: parseInt(context.user.get.details.embaettisnumer),
    }));
  }, [setFormState, kjosandi, context]);

    // Óli: temp fix - falið þar sem ekki þarf lengur að taka fram hvers vegna aðstoð var veitt, gæti breyst aftur.
  // Need only validate some basic rules regarding
  // help voters get from kjörstjóri or fulltrúi
  //const isFormValid = () => {
    // If voter gets no help
    //if (!formState.adstodKjorstjori && !formState.adstodFulltrui) {
    //  return true;
    //}

    // If voter gets help
    //if (formState.adstodKjorstjori || formState.adstodFulltrui) {
    //  // Can only select one of the two
    //  if (formState.adstodBlindur && formState.adstodHond) return false;

    //  // Because of the process above the following statement works
    //  if (formState.adstodBlindur || formState.adstodHond) {
    //    return true;
    //  }
  //  }

  //  return false;
  //};

  return (
    <Fragment>
      <KjosandiInfo kjosandi={kjosandi} fjoldiAtkvaeda={fjoldiAtkvaeda} />

      <KjosandiAdstod formState={formState} setFormState={setFormState} />

      <KjosandiAtkvaedi formState={formState} setFormState={setFormState} atkvaediOptions={atkvaediOptions} />

      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Button onClick={handleBack}>Til baka</Button>
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" onClick={handleNext}>
            Áfram
          </Button>
        </Grid>
      </Grid>

    </Fragment>
  );
}
